export default {
  namespaced: true,
  state: {
    orderStatu: ''
  },
  mutations: {
    SET_OrderStatu: function SET_OrderStatu(state, value) {
      state.orderStatu = value;
    }
  },
  actions: {
    setOrderStatu: function setOrderStatu(_ref, value) {
      var commit = _ref.commit;
      commit('SET_OrderStatu', value);
    }
  }
};